module.exports = __webpack_public_path__ + "static/foto-mates-0b7361db87f15f06d547e5bb2becf469.png";